module.exports = __webpack_public_path__ + "img/info.288308a9.svg";